<template lang="pug">
.free-coupons-container
  .coupons
    template(v-if="coupons && coupons.length")
      .coupon-item(v-for="(item, index) in coupons2Show")
        CardCouponsItem(
          :info="item",
          @btn="clickCoupon(item, index)",
          @use="use(item)"
        )
    template(v-else)
      Empty
  .more.flex-mid(
    v-if="coupons && coupons.length > 3 && !more",
    @click="showMore"
  )
    span 更多好券
    .common-arrow-down
  DoubleModal(ref="modal", @confirm="double")
</template>

<script>
import Toast from '@/components/toast';
import Empty from '@/components/empty';
import { marketDistribute } from '@/api/card';
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import DoubleModal from './double-modal';
import CardCouponsItem from './card-coupon-item';
import { getTokenAndKey } from '../../../utils';
import {
  doubleMarketCoupon,
  handleClickCoupon,
  handleMarketCoupons,
  welfareGoCoupon,
} from '../utils';
import { CARD_COUPON_TYPE, TIME_COUPON_STATUS } from '../consts';

export default {
  components: {
    CardCouponsItem,
    Empty,
    DoubleModal,
  },
  props: {
    activity: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      coupons: [],
      more: false,
      // activity: {
      //   componentKey: 'GET_PROPERTY20210205021931234344',
      //   activityCode: 'activity20210205021904448763',
      // },
    };
  },
  computed: {
    coupons2Show() {
      if (this.coupons.length > 3 && !this.more) {
        return this.coupons.slice(0, 3);
      }
      return this.coupons;
    },
  },
  watch: {
    coupons2Show: {
      deep: true,
      handler(curVal) {
        (curVal || []).forEach((item) => {
          UBT.moduleExpose({
            pageId: 'Welfare',
            categoryId: 'platform',
            moduleId: 'coupon_state',
            contentId: 'coupon_state',
            exposureTimes: 1,
            businessInfo: {
              coupon_state: item.status || '未知',
              coupon_name: item.title,
              activity: item.type === CARD_COUPON_TYPE.TIME_COUPON ? '0' : '1',
            },
          });
        });
      },
    },
  },
  methods: {
    showMore() {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'more_coupon',
        categoryId: 'platform',
        businessInfo: {
          activity: '1',
        },
      });
      this.more = true;
    },
    // 直接用
    use(item) {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'use_go',
        categoryId: 'platform',
        businessInfo: {
          coupon_name: item.title,
          activity: '1',
          use: '1',
        },
      });
      welfareGoCoupon();
    },
    clickCoupon(item, index) {
      if (item.status === TIME_COUPON_STATUS.USE) {
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'use_go',
          categoryId: 'platform',
          businessInfo: {
            coupon_name: item.title,
            activity: '1',
            use: '0',
          },
        });
        welfareGoCoupon();
        return;
      }
      if (item.status === TIME_COUPON_STATUS.DOUBLE) {
        this.$refs.modal.open({ item, index });
        return;
      }
      if (item.status === TIME_COUPON_STATUS.NONE) {
        Toast.show('很遗憾，券已被领完');
        return;
      }
      handleClickCoupon(this.activity, item, {
        type: CARD_COUPON_TYPE.FREE_COUPON,
      }).then(() => {
        this.$emit('coupon');
        this.getData();
      });
    },
    // 膨胀
    double({ item }) {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'expand_go',
        categoryId: 'platform',
        businessInfo: {
          coupon_name: item.title,
          activity: '0',
        },
      });
      doubleMarketCoupon(this.activity, item.detail)
        .then(() => {
          this.getData();
          Toast.show('膨胀成功');
        })
        .catch((e) => Toast.showError(e));
    },
    async getData() {
      if (!this.activity) {
        return Promise.resolve();
      }
      const { activityCode, componentKey } = this.activity;
      const { token } = await getTokenAndKey();
      const data = await marketDistribute({
        activityCode,
        token,
        channelId: env.platformCode,
        methodName: 'matchPeriodSwellPrize',
        param: JSON.stringify({ activityCode, componentKey }),
      })
        .then((v) => v.data || [])
        .catch(() => []);
      this.coupons = data.reduce(
        (res, cur) => res.concat(
          handleMarketCoupons(cur.prizeMatchDetails, {
            sku: true,
            type: CARD_COUPON_TYPE.FREE_COUPON,
          }),
        ),
        [],
      );
      return Promise.resolve();
    },
  },
};
</script>

<style lang="less" scoped>
.free-coupons-container {
  .coupons {
    display: flex;
    flex-direction: column;
  }

  .coupon-item {
    &:not(:last-of-type) {
      margin-bottom: 0.12rem;
    }
  }

  .more {
    font-size: 0.12rem;
    color: #999;
    margin-top: 0.16rem;

    .common-arrow-down {
      border-color: #999;
    }
  }
}
</style>
